import { z } from 'zod';
import { requiredUuidString } from '../zod-helpers/index.js';
// Upper bound stays well under the Decimal(28,9) column's overflow point.
export const stageWorkOrderComponentInputSchema = z.object({
    workOrderItemId: requiredUuidString('Component is required.', 'Invalid component selection.'),
    tagId: requiredUuidString('Batch is required.', 'Invalid batch selection.'),
    quantity: z
        .number()
        .positive('Quantity must be greater than zero.')
        .max(1_000_000_000, 'Quantity must be 1,000,000,000 or less.'),
});
//# sourceMappingURL=stage-component-input.js.map